import { Person } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { Profile } from "./Profile";
import { currentFeatures } from "../../configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { PractitionerProfile } from "./PractitionerProfile";

export function useProfile() {
  const { access } = useSessionContext();
  const configs: IFeatures = {
    active: currentFeatures.profile,
    path: "/profile",
    icon: Person,
    text: "Perfil",
    avatarMenu: true,
    avatarIndex: 0,

    component: () =>
      access.type === "professional" ? <PractitionerProfile /> : <Profile />,
  };

  return configs;
}
